import {computed, observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMesTexto} from "../../../utils/functions";
import {getMensagemDeErro} from "../../../utils/functions";
import React from "react";

export default class SolicitacaoMensalDivisaoStore {
    @observable erro;
    @observable carregando;
    @observable dados;
    @observable divisoes;
    @observable rankings;

    constructor() {
        this.indicadorService = new IndicadorService();
    }

    formatAnoMes = (anoMes) => {
        try {
            return `${getMesTexto(anoMes.toString().substring(4))}/${anoMes.toString().substring(0, 4)}`
        } catch(error) {}
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findSolicitacaoMensalDivisao(filtro).then(response => {
            const formattedData = response.data.map((data) => ({
                ...data, anoMes: this.formatAnoMes(data.anoMes)
            }))

            const anosMesesAgrupados = _.groupBy(formattedData, (d) => d.anoMes);
            const anosMeses = Object.keys(anosMesesAgrupados);
            const divisoesAgrupadas = _.groupBy(formattedData, (d) => d.divisao);
            const divisoes = Object.keys(divisoesAgrupadas);
            const rankingAgrupados = _.groupBy(formattedData, (d) => d.ranking);

            let dados = [];
            _.forEach(anosMeses, (anoMes) => {
                let dado = { nome: anoMes};
                let ranks = {1: 'Top 1', 2: 'Top 2', 3: 'Top 3', 4: 'Outros'}

                const anosMesesRanking = anosMesesAgrupados[anoMes];

                _.forEach(anosMesesRanking, (anoMesRanking) => {
                    dado = { ...dado, [`${ranks[anoMesRanking.ranking]}-divisao`]: `${anoMesRanking.divisao} (${anoMesRanking.quantidade})`, [ranks[anoMesRanking.ranking]]:  anoMesRanking.quantidade};
                });

                dados = [ ...dados, dado ];

            });

            this.divisoes = divisoes;
            this.dados = dados;
            this.carregando = false;
            this.rankings = ['Top 1', 'Top 2', 'Top 3', 'Outros'];
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }
}
